import { ReactNode } from "react";

export const createDefaultTableOptions = () => {

    const options = {
        filter: false,
        search: false,
        print: false,
        download: false,
        viewColumns: false,
        selectableRows: undefined,
        elevation: 0,
        //customFooter: () : ReactNode => { return null; },
        setTableProps: () => {
            return {
              size: "small",
              padding: "1px"
            }
        }
    };

    return options;
}